import { useQueries } from '@tanstack/react-query';
import { fetchAvailableSlots, type AvailableSlot } from '@/hooks/usePublicBooking';

export function useAvailableSlotsWeek(
  clinicSlug: string | null | undefined,
  serviceId: string | null | undefined,
  clinicianId: string | null | undefined,
  dates: string[],
) {
  const queries = useQueries({
    queries: dates.map((date) => ({
      queryKey: [
        'public-booking',
        'slots',
        clinicSlug ?? null,
        serviceId ?? null,
        clinicianId ?? null,
        date,
      ] as const,
      enabled: Boolean(clinicSlug && serviceId && date),
      queryFn: async (): Promise<AvailableSlot[]> => {
        if (!clinicSlug || !serviceId || !date) return [];
        return fetchAvailableSlots({
          clinicSlug,
          serviceId,
          clinicianId,
          date,
        });
      },
      staleTime: 0,
      refetchOnMount: 'always' as const,
    })),
  });

  const slotsByDate = new Map<string, AvailableSlot[]>();
  dates.forEach((date, index) => {
    slotsByDate.set(date, queries[index]?.data ?? []);
  });

  return {
    slotsByDate,
    isLoading: queries.some((query) => query.isLoading || query.isFetching),
    isError: queries.some((query) => query.isError),
  };
}
